/**
 * Resolves a trikot image path to an absolute path
 * @param {string} imagePath - The image path from the database
 * @returns {string} The resolved image path
 */
export const resolveTrikotImagePath = (imagePath) => {
  // If the path is already a full URL, return it as is
  if (imagePath?.startsWith("http://") || imagePath?.startsWith("https://")) {
    return imagePath;
  }

  // If the path already starts with a slash, remove the leading slash
  const normalizedPath = imagePath?.startsWith("/")
    ? imagePath.substring(1)
    : imagePath;

  const publicUrl = process.env.PUBLIC_URL || "";
  const prefix = publicUrl.endsWith("/") ? publicUrl.slice(0, -1) : publicUrl;
  return prefix ? `${prefix}/${normalizedPath}` : `/${normalizedPath}`;
};
